import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { authActions } from "./../../store/reducers/authReducer";


// CSS
import "./DefaultLayout.scss"
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";

const DefaultLayout = () => {

  const isAuthenticated = useSelector(
    (state: any) => state.auth.isAuthenticated
  );

  const [collapsed, setCollapsed] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setInitialUrl(location));
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate, dispatch, location]);

  const onToggle = () => {
    setCollapsed(!collapsed);
  }

  return (
    <div className="page-container w-full h-screen flex flex-row overflow-hidden bg-[#f8fafc]">
      <Sidebar collapsed={collapsed} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggle={onToggle} />
        <main className="content flex-1 p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default DefaultLayout;